import { useMutation } from "react-query"
import { uploadResultDocument } from "../services"
import usePopup from "../../../hooks/usePopup"

const useUploadLabFile = (onSuccess?:()=>void,onError?:()=>void)=>{
    const {showSnackbar} = usePopup()
     return useMutation(uploadResultDocument,   {
        onSuccess: (result) => {
          showSnackbar({
            message: result.responseMessage,
            open: true,
            variant: result.responseIndicator == "success" ? "success" : "error",
            duration: 3000,
          });
          if(onSuccess){onSuccess()}
        },
        onError: (e: any) => {
          if(onError){onError()}
          showSnackbar({
            message:
              e?.response?.data?.responseMessage || "Something went wrong !",
            open: true,
            variant: "error",
            duration: 3000,
          });
        },
      })

}

export default useUploadLabFile